export const DashboardArrow = ({...props}) => {
    return (
        <>
            <svg width="20" height="12" viewBox="0 0 20 12" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
                <path d="M20 1V5.15405C20 5.70605 19.552 6.15405 19 6.15405C18.448 6.15405 18 5.70605 18 5.15405V3.41406L12.414 9C11.635 9.78 10.365 9.78 9.58601 9L7.00001 6.41406L1.70701 11.707C1.51201 11.902 1.25601 12 1.00001 12C0.744007 12 0.488006 11.902 0.293006 11.707C-0.0979941 11.316 -0.0979941 10.684 0.293006 10.293L5.58601 5C6.36501 4.22 7.63501 4.22 8.41401 5L11 7.58594L16.586 2H14.846C14.294 2 13.846 1.552 13.846 1C13.846 0.448 14.294 0 14.846 0H19C19.13 0 19.26 0.0269043 19.382 0.0769043C19.627 0.178904 19.821 0.37292 19.923 0.61792C19.973 0.73992 20 0.87 20 1Z" fill="#686868"/>
            </svg>
        </>
    );
}

